import React, { Fragment, Component } from 'react'
import Helmet from 'react-helmet'
import config from '../../data/SiteConfig'
import withRoot from './withRoot'
import Popup from '../components/Popup'

import Header from '../components/Header/'
import Footer from '../components/Footer/Footer'

import favicon from '../assets/img/BNLfavicon-32x32.png'

import '../assets/scss/material-kit-pro-react.scss'

class MainLayout extends Component {
  state = {
    popupShown: true,
  }
  render() {
    const { children, location } = this.props

    return (
      <Fragment>
        <Helmet
          defaultTitle={config.siteTitle}
          titleTemplate={`${config.siteTitle} - %s`}
        >
          <link rel="dns-prefetch" href="//fonts.googleapis.com" />
          <link rel="shortcut icon" href={favicon} type="image/x-icon" />
          <meta name="description" content={config.siteDescription} />
        </Helmet>
        <Header transparentHeader={location.pathname === '/'} />
        {children()}
        {this.state.popupShown && (
          <Popup
            hidePopup={() => this.setState({ popupShown: false })}
            shown={this.state.popupShown}
            scrollShow={location.pathname === '/'}
          />
        )}
        <Footer config={config} />
      </Fragment>
    )
  }
}

export default withRoot(MainLayout)



// WEBPACK FOOTER //
// ./src/layouts/index.jsx